import React from "react";
import { Link } from "react-router-dom";
import { Timeout } from "localResouces";
import ContentLoading from "./ContentLoading";
import { getTranslation as translate } from "logic/LocaleManager";

const fallBackBorderColor = "darkgrey";
const fallBackCaption = "Ooops!";
const fallBackMessage = "Something went wrong...";

function ApplicationMessage(props) {
  const { borderColor, caption, message, action, actionText } = props;
  const effectiveBorderColor = borderColor ? borderColor : fallBackBorderColor;
  const effectiveCaption = caption ? caption : translate("appMessages.defaultCaption", fallBackCaption);
  const effectiveMessage = message ? message : translate("appMessages.defaultMessage", fallBackMessage);

  const wrapper = {
    position: "relative",
    borderStyle: "dashed",
    borderWidth: "4px",
    borderColor: effectiveBorderColor,
    padding: "2em",
  };

  const loadingWrapper = {
    padding: "1em"
  };

  const headline = {
    textAlign: "center"
  };

  return (
    <div className={"dx-theme-background-color dx-widget"} style={wrapper}>
      <div className={'dx-theme-accent-as-text-color'}>
        <div className={"ui-default-headline"} style={headline}>{effectiveCaption}</div>
      </div>
      <div style={loadingWrapper}>
        {props.children}
      </div>
      <div>
        {effectiveMessage}
      </div>
      {actionText
        ? (
          <Link
            to=""
            onClick={(e) => {
              e.preventDefault();
              action();
            }}
          >
            {actionText}
          </Link>
        )
        : null
      }
    </div>
  );
}

export function ApplicationIdleMessage(props) {
  return (
    <ApplicationMessage
      borderColor="darkgrey"
      caption={translate("appIdle.caption", "You have gone idle")}
      message={translate("appIdle.message", "Click on the link below to continue working")}
      actionText={translate("appIdle.actionText", "I am still here")}
      {...props}
    >
      <div style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
        <img src={Timeout} width={50} alt="timeout" />
      </div>
    </ApplicationMessage>
  );
}

export function BosServerUnavailableMessage(props) {
  return (
    <ApplicationMessage
      borderColor="firebrick"
      caption={translate("serverUnavailable.caption", "Ooops, BOS Server unavailable :-(")}
      message={translate("serverUnavailable.message", "Wait for the server to be available again")}
      {...props}
    >
      <ContentLoading />
    </ApplicationMessage>
  );
}
